import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'

export const PANEL_MIN_HEIGHT = 500

const withLoadingFeedBack =
  (Component) =>
  ({ isLoading, data, ...other }) => {
    if (isLoading) {
      return (
        <div className="positionRelative" style={{ height: PANEL_MIN_HEIGHT }}>
          <Loading />
        </div>
      )
    }

    if (!Object.keys(data.dataByRowId).length) {
      return (
        <div className="positionRelative" style={{ height: PANEL_MIN_HEIGHT }}>
          <Notification />
        </div>
      )
    }

    return <Component {...other} />
  }

export default withLoadingFeedBack
